import { ManagerOfCompany, Pagination } from '@interfaces';
import { Action, createReducer, on } from '@ngrx/store';
import * as managerActions from './manager.actions';
import { ManagerState, initialState } from './manager.state';

const reducer = createReducer(
  initialState,
  on(managerActions.getMyManagedCompanies, state => ({
    ...state,
    loadingManagedCompanies: true,
  })),
  on(managerActions.getMyManagedCompaniesSuccess, (state, { managedCompanies }) => ({
    ...state,
    loadingManagedCompanies: false,
    managedCompanies,
  })),
  on(managerActions.getMyManagedCompaniesError, (state, { errorMessage }) => ({
    ...state,
    loadingManagedCompanies: false,
    errorMessage,
  })),

  on(managerActions.searchProcessesOfManagedEmployees, state => ({
    ...state,
    loadingProcesses: true,
  })),
  on(managerActions.searchProcessesOfManagedEmployeesSuccess, (state, { processes }) => ({
    ...state,
    loadingProcesses: false,
    processes: processes.data,
    processesPagination: processes.pagination,
  })),
  on(managerActions.searchProcessesOfManagedEmployeesError, (state, { errorMessage }) => ({
    ...state,
    loadingProcesses: false,
    errorMessage,
  }))
);

export function managerReducer(state: ManagerState | undefined, action: Action): ManagerState {
  return reducer(state, action);
}
